import api from '@/services/index.js'

//withdrawTran
async function Initialize(callback) {
  await api
    .get('/fund-composite/v1/withdrawal/condition')
    .then((v) => {
      callback({ status: true, data: v.data, message: '' })
    })
    .catch((e) => {
      callback({ status: false, data: '', message: e.message })
    })
    .finally(() => {})
}

async function Withdraw(input, minWithdraw, callback) {
  if (input < minWithdraw) {
    callback({
      status: false,
      data: '',
      message: `ถอนเงินขั้นต่ำ ${minWithdraw} บาท`,
    })
    return
  }
  await api
    .post('/fund-composite/v1/withdrawal', {
      Amount: parseFloat(input),
      Channel: 'BANK',
    })
    .then((v) => {
      if (v.success == true) {
        callback({ status: true, data: v, message: 'ถอนเงินสำเร็จ' })
      } else {
        callback({ status: false, data: '', message: v.message })
      }
    })
    .catch((e) => {
      callback({ status: false, data: '', err: e.message })
    })
    .finally(() => {})
}
export { Initialize, Withdraw }



// WEBPACK FOOTER //
// ./src/services/modules/withdraw.js